import React from 'react'

import BingoSquareA from './bingosquares/BingoSquareA'
import BingoSquareB from './bingosquares/BingoSquareB'
import BingoSquareC from './bingosquares/BingoSquareC'
import BingoSquareD from './bingosquares/BingoSquareD'
import BingoSquareE from './bingosquares/BingoSquareE'
import BingoSquareF from './bingosquares/BingoSquareF'
import BingoSquareG from './bingosquares/BingoSquareG'
import BingoSquareH from './bingosquares/BingoSquareH'
import BingoSquareI from './bingosquares/BingoSquareI'
import BingoSquareJ from './bingosquares/BingoSquareJ'
import BingoSquareK from './bingosquares/BingoSquareK'
import BingoSquareL from './bingosquares/BingoSquareL'
import BingoSquareM from './bingosquares/BingoSquareM'
import BingoSquareO from './bingosquares/BingoSquareO'
import BingoSquareP from './bingosquares/BingoSquareP'
import BingoSquareQ from './bingosquares/BingoSquareQ'
import BingoSquareR from './bingosquares/BingoSquareR'
import BingoSquareS from './bingosquares/BingoSquareS'
import BingoSquareT from './bingosquares/BingoSquareT'
import BingoSquareU from './bingosquares/BingoSquareU'
import BingoSquareV from './bingosquares/BingoSquareV'
import BingoSquareW from './bingosquares/BingoSquareW'
import BingoSquareX from './bingosquares/BingoSquareX'
import BingoSquareY from './bingosquares/BingoSquareY'
import BingoSquareZ from './bingosquares/BingoSquareZ'


import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

import '../sytles/Card.css'


const useStyles = makeStyles({
    root: {
      minWidth: 275,
      minHeight: 550,
      backgroundColor: 'white'
    },
    bullet: {
      display: 'inline-block',
      margin: '0 2px',
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
      color: 'white'
    },
    pos: {
      marginBottom: 12,
      color: 'white'
    },

  });
  
 const RuleCard = () => {
    const classes = useStyles();
    const bull = <span className={classes.bullet}>•</span>;
  
    return (
      <Card className={classes.root}>
        <CardContent>
          <Typography variant="h5" component="h2">
            B{bull}I{bull}N{bull}G{bull}O
          </Typography>
        </CardContent>
        <CardActions>
            <BingoSquareA />
            <BingoSquareB />
            <BingoSquareC />
            <BingoSquareD />
            <BingoSquareE />
        </CardActions>
        <CardActions>
            <BingoSquareF />
            <BingoSquareG />
            <BingoSquareH />
            <BingoSquareI />
            <BingoSquareJ />
        </CardActions>
        <CardActions>
            <BingoSquareK />
            <BingoSquareL />
            <BingoSquareM />
            <BingoSquareO />
            <BingoSquareP />
        </CardActions>
        <CardActions>
            <BingoSquareQ />
            <BingoSquareR />
            <BingoSquareS />
            <BingoSquareT />
            <BingoSquareU />
        </CardActions>
        <CardActions>
            <BingoSquareV />
            <BingoSquareW />
            <BingoSquareX />
            <BingoSquareY />
            <BingoSquareZ />
        </CardActions>
      </Card>
    );
  }


export default RuleCard